module.exports = __webpack_public_path__ + "static/chicken-tinder-mobile-be6fbd29c80b9b99e5077a3a7f5e2825.png";